import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { PageHeader } from "@/components/common";
import { DateRange, TxTable } from "@/components/TxTable";
import { daysAgoStr, rupiah, todayStr, TX_LABELS } from "@/lib/format";

export default function RiwayatPage() {
  const [range, setRange] = useState({ start: daysAgoStr(7), end: todayStr() });
  const [type, setType] = useState("semua");
  const [nik, setNik] = useState("");
  const [rows, setRows] = useState(null);

  useEffect(() => {
    const params = { start: range.start, end: range.end };
    if (type !== "semua") params.type = type;
    if (nik.length === 16) params.nik = nik;
    let stale = false;
    const t = setTimeout(() => {
      api.get("/transactions", { params }).then((r) => { if (!stale) setRows(r.data); }).catch(() => { if (!stale) setRows([]); });
    }, 300);
    return () => { stale = true; clearTimeout(t); };
  }, [range, type, nik]);

  const sum = (t) => (rows || []).filter((r) => r.type === t).reduce((s, r) => s + r.amount, 0);

  return (
    <div>
      <PageHeader eyebrow="Monitoring" title="Riwayat Transaksi" subtitle="Filter berdasarkan rentang tanggal, jenis transaksi, atau NIK anggota." />
      <div className="panel mb-6 flex flex-col lg:flex-row lg:items-center gap-3" data-testid="history-filters">
        <DateRange start={range.start} end={range.end} onChange={(start, end) => setRange({ start, end })} testId="history-range" />
        <Select value={type} onValueChange={setType}>
          <SelectTrigger className="h-11 lg:w-44" data-testid="history-type-select"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="semua">Semua Jenis</SelectItem>
            {Object.entries(TX_LABELS).map(([k, v]) => <SelectItem key={k} value={k} data-testid={`history-type-${k}`}>{v}</SelectItem>)}
          </SelectContent>
        </Select>
        <div className="relative lg:w-64">
          <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input value={nik} onChange={(e) => setNik(e.target.value.replace(/\D/g, "").slice(0, 16))} placeholder="NIK anggota (16 digit)" className="h-11 pl-10 font-mono" data-testid="history-nik-input" />
        </div>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 mb-6">
        {Object.entries(TX_LABELS).map(([k, v]) => (
          <div key={k} className="rounded-2xl border bg-card p-4" data-testid={`history-sum-${k}`}><p className="eyebrow">{v}</p><p className="font-mono font-semibold mt-2">{rupiah(sum(k))}</p></div>
        ))}
      </div>
      <div className="panel">{rows === null ? <p className="text-muted-foreground">Memuat...</p> : <TxTable rows={rows} testId="history-table" />}</div>
    </div>
  );
}
